import React from 'react'
import PropTypes from 'prop-types'
import {isServer} from '../../utils/utils'

/**
 * Internal widget to prevent linked css from blocking page rendering by loading them after the page has loaded.
 */
const WidgetStylesheet = ({children: _children, media, ...rest}) => {
    return <link {...rest} media={isServer ? 'print' : media} />
}

WidgetStylesheet.propTypes = {
    children: PropTypes.string,
    media: PropTypes.string
}

export default WidgetStylesheet
